exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-image[data-v-1a522989] {\n  width: 90px;\n  height: 90px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.category-select[data-v-1a522989] {\n  height: calc(2.6em + 0.75rem + 2px);\n  font-size: 30px;\n  border-bottom: solid #91353a 3px !important;\n  border-radius: 0;\n}\n", ""]);

// exports
